import BaseModel from "../core/BaseModel";
export default class ContractorUserModel extends BaseModel {
  constructor() {
    super(
      {
        name: "contractor_user",
        tableName: "users",
        label: "Danh Sách Nhân Viên Nhà Thầu",
          display_key: 'fullname',
        /* display_key: 'fullname',
                 default_order: { key: 'updated_at', direction: 'asc' }*/
      },
      {
        stt: {
          name: "stt",
          label: "STT",
          type: "Computed",
          class: "xs-col",
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },
        id: {
          name: "id",
          type: "Uuid",
          label: "ID",
          primaryKey: true,
          display: false,
        },
        avatar : {
          name: 'avatar', 
          type: "Image", 
          label: 'Hình đại diện',
        },
        fullname: {
          name: "fullname",
          type: "String",
          label: "Tên hiển thị",
          class: "large-col",
          filter: { type: "input", match: "contains" },
        },
        contractor_name: {
          name: "contractor_name",
          label: "Nhà thầu",
          type: "String",
          // filter: { type: "input", match: "contains" },
        },
        id_card: {
          name: "id_card",
          label: "Căn cước Công dân",
          type: "String",
          filter: { type: "input", match: "contains" },
        },
        work: {
          name: "work",
          label: "Công việc",
          type: "String",
          filter: { type: "input", match: "contains" },
        },
        birthday: {
          name: "birthday",
          label: "Ngày sinh",
          type: "Date",
          filter: { type: 'DateRange', match: 'contains'},
        },
        educated_status: {
          name: "educated_status",
          label: "Trạng thái đào tạo",
          type: "Selection",
          class: 'center',
          // options: [
          //   { value: "OUTDATED", label: "Quá hạn" },
          //   { value: "VALID", label: "Còn hạn" },
          // ],
          // filter: {
          //   type: "select",
          //   optionLabel: "label",
          //   optionKey: "value",
          //   match: "equals",
          // },
        },
        num_file: {
          name: "num_file",
          label: "Trạng thái hồ sơ",
          type: "CustomUrl",
          class: 'center',
          computed: (data) => {
            data.num_file = 0;
          }
        },
        work_status: {
          name: "work_status",
          label: "Trạng thái làm việc",
          type: "CustomUrl",
          class: 'center',
        },
        violation_status: {
          name: "violation_status",
          label: "Vi phạm",
          type: "Selection",
          custom: 'SelectionText',
          class: 'center',
          options: [
            { value: "no", label: "Không" },
            { value: "banned", label: "Vi phạm" },
          ],
          filter: {
            type: "select",
            optionLabel: "label",
            optionKey: "value",
            match: "equals",
          },
        },
        violation_count: {
          name: "violation_count",
          label: "Số lần vi phạm",
          type: "CustomUrl",
          class: 'center',
        },
      }
    );
  }
}
